export default "__VITE_ASSET__BS0X6m6S__"